import { CHANGE_COLOR, CHANGE_COLORS }  from '../actions/actionTypes'
import { addColorScheme } from '../actions';

const currentColors = ( state = [], action ) => {
	switch( action.type ){
		case CHANGE_COLOR: {
			const {id, color} = action;
			let newState = [...state];
			newState[id]=color;
			return newState;
		}
		case CHANGE_COLORS: {
			return action.colors;
		}
		default:
			return state;
	}
}

export default currentColors;


// WEBPACK FOOTER //
// ./src/reducers/currentColors.js